import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import { CompanyService } from '../../../core/services/company/company.service';

@Component({
  selector: 'app-footer',
  imports: [MatIcon, RouterLink],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  private readonly companyService = inject(CompanyService);

  readonly company = this.companyService.company;
  readonly whatsappUrl = this.companyService.whatsappUrl;
  readonly googleMapsUrl = this.companyService.googleMapsUrl;
  readonly currentYear = new Date().getFullYear();
}
